import { useState, useEffect, useRef } from "react";
import { useCart } from "../context/CartContext";
import QuickAddModal from "./QuickAddModal";
import styles from "./ProductCard.module.css";

export default function ProductCard({ item, index }) {
  const videoRef = useRef(null);
  const cardRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [visible, setVisible] = useState(false);
  const [added, setAdded] = useState(false);
  const [quickOpen, setQuickOpen] = useState(false);
  const { addToCart, items } = useCart();

  const inCart = items.some((i) => i.id === item.id);
  const installment = Math.ceil(item.price / 3).toLocaleString();
  const isImage = (src) => /\.(png|jpg|jpeg|webp)/i.test(src);
  const isPreorder = item.preorder === true;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  const handlePlay = () => {
    document.querySelectorAll("video").forEach((v) => {
      if (v !== videoRef.current) { v.pause(); v.currentTime = 0; }
    });
    if (playing) { videoRef.current.pause(); setPlaying(false); }
    else { videoRef.current.play(); setPlaying(true); }
  };

  const handleInquire = () => {
    const msg = encodeURIComponent(`Hello! I'm interested in the ${item.name}. Could you provide more details?`);
    const link = document.createElement("a");
    link.href = `https://wa.me/94765851400?text=${msg}`;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };

  const handleAddToCart = () => setQuickOpen(true);


  const handleViewProduct = () => {
    window.location.href = `/product/${item.id}`;
  };

  return (
    <div ref={cardRef} className={styles.card}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transition: `opacity 0.7s ease ${index * 0.07}s, transform 0.7s ease ${index * 0.07}s`,
      }}
    >
      <div className={styles.mediaContainer} onClick={isImage(item.src) ? handleViewProduct : handlePlay}>
        {isImage(item.src) ? (
          <img src={item.src} alt={item.name} className={styles.video} />
        ) : (
          <video ref={videoRef} src={item.src} preload="metadata" loop muted playsInline
            onEnded={() => setPlaying(false)} className={styles.video} />
        )}
        <div className={styles.videoOverlay} />

        <span className={styles.gemBadge}>{item.gem}</span>

{!isImage(item.src) && !playing && (
          <div className={styles.playBtn}><div className={styles.playArrow} /></div>
        )}
        {!isImage(item.src) && playing && (
          <div className={styles.pauseBtn}>
            <div className={styles.pauseBar} /><div className={styles.pauseBar} />
          </div>
        )}
      </div>

      <div className={styles.info}>
        <h3 className={styles.name} onClick={handleViewProduct}>{item.name}</h3>
        {isPreorder && <div style={{display:"flex"}}><span className={styles.preorderTag}>Pre-Order</span></div>}
        <p className={styles.description}>{item.description}</p>

        <div className={styles.footer}>
          <span className={styles.price}>LKR {item.price.toLocaleString()}</span>

          <div className={styles.mintpayLine}>
            <span className={styles.mintpayText}>or 3 × LKR {installment} with</span>
            <img src="/mintpay-logo.webp" alt="Mintpay" className={styles.mintpayLogo} />
          </div>

          <div className={styles.btnRow}>
            <button className={styles.inquireBtn} onClick={handleInquire}>
              <img src="/whatsapp-logo.png" alt="WhatsApp" width={14} height={14} />
              Inquire
            </button>
            <button
              className={`${styles.cartBtn} ${inCart ? styles.cartBtnAdded : ""}`}
              onClick={handleAddToCart}
              disabled={inCart}
            >
              {inCart ? "In Cart ✓" : added ? "Added!" : "Add to Cart"}
            </button>
          </div>
          <button className={styles.viewBtn} onClick={handleViewProduct}>
            View Details
          </button>

          {quickOpen && (
            <QuickAddModal product={item} onClose={() => setQuickOpen(false)} />
          )}
        </div>
      </div>
    </div>
  );
}